// @ts-nocheck
/**
 * Top-bar Support button (all roles): the same headset icon used in the client
 * chat, linking to /support, with a notification-style badge counting replies
 * the user received AFTER their last message, in non-closed tickets. Refreshed
 * live via Socket.IO (the user's own room gets `support_changed`).
 */
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Badge, Box, Tooltip } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { socket } from "../../services/socket.io/socket.io.config";
import { fetchSupportMyUnread } from "../../api/support";

export default function SupportNavButton({ isSmallScreen }) {
  const [count, setCount] = useState(0);

  const load = async () => {
    const { response } = await fetchSupportMyUnread();
    setCount(response?.data?.count || 0);
  };

  useEffect(() => {
    load();
    const onChanged = () => load();
    socket.on("support_changed", onChanged);
    return () => socket.off("support_changed", onChanged);
  }, []);

  return (
    <Tooltip title="Support">
      <Box sx={{ lineHeight: 0, marginRight: isSmallScreen ? "12px" : "1.5rem", display: "flex" }}>
        <NavLink to="/support">
          <Badge
            badgeContent={count}
            color="error"
            overlap="circular"
            sx={{ "& .MuiBadge-badge": { fontSize: 10, height: 18, minWidth: 18 } }}
          >
            <SupportAgentIcon
              sx={{
                color: "#fff",
                fontSize: 32,
                verticalAlign: "middle",
                transition: "color .15s",
                "&:hover": { color: "#00EEC5" },
              }}
            />
          </Badge>
        </NavLink>
      </Box>
    </Tooltip>
  );
}
